import { emitScrollEvent } from './eventEmitter.js';

const buildTableTrackingData = (tableTracking, featureIndex) => {
  const { labels } = tableTracking;

  return {
    ...tableTracking,
    position: parseInt(featureIndex, 10),
    status: 'visible',
    labels: {
      ...labels,
      promo_FilledSlots: labels.promo_FilledSlots
    }
  };
};

const buildRecommendationsTrackingData = (recommendationsTracking) => {
  return recommendationsTracking.map((tracking) => {
    return {
      ...tracking,
      status: 'visible'
    };
  });
};

const initializeRow = (numberOfColumns) => {
  let data = [];

  for (let i = 0; i < numberOfColumns; i++) {
    data.push('');
  }
  return data;
};

const mergeToPayload = (table) => {
  let payload = {};
  for (let pair of Object.entries(table)) {
    payload[pair[0]] = [pair[1].join('|')];
  }
  return payload;
};

const buildTrackingLabels = (columns) => {
  let table = {};
  const numberOfColumns = columns.length;
  for (let i = 0; i < numberOfColumns; i++) {
    let currentColumn = columns[i];
    for (let property of Object.entries(currentColumn)) {
      if (!property[1]) {
        continue;
      }
      if (!table[property[0]]) {
        table[property[0]] = initializeRow(numberOfColumns);
      }
      table[property[0]][i] = property[1];
    }
  }
  return mergeToPayload(table);
};

export default (
  tableTracking,
  recommendationsTracking,
  featureIndex,
  scrollDirection,
  recommendationsMeta,
  mainVariationId
) => {
  const event = {
    name: scrollDirection,
    features: [
      buildTableTrackingData(tableTracking, featureIndex),
      ...buildRecommendationsTrackingData(recommendationsTracking)
    ]
  };
  const productVariationId = {
    product_VariationId: [mainVariationId]
  };
  const cleanRecommendationsMeta = recommendationsMeta.map((recommendationMeta) => {
    const cleanRecommendationMeta = { ...recommendationMeta };
    delete cleanRecommendationMeta.product_VariationId;
    return cleanRecommendationMeta;
  });
  const additionalRecommendationsTrackingLabels = buildTrackingLabels(cleanRecommendationsMeta);
  const additionalScrollTrackingLabels = {
    ...additionalRecommendationsTrackingLabels,
    ...productVariationId
  };
  emitScrollEvent(event, additionalScrollTrackingLabels);
};
